<template>
  <div class="settings">
    <Breadcrumbs :items="breadcrumbs">
      <rp-button type="primary" @click="openAddLanguage">New Notification</rp-button>
    </Breadcrumbs>

    <rp-table
      name="languages"
      :results="getNotifications"
      noPagination
      :key="tableState"
      :headings="[{heading: 'content', key: 'contentDisplay', }, {heading: 'last updated', key: 'updated'}, {heading: 'edit', key: 'edit', button: true}, {heading: 'remove', key: 'remove', button: true}]">
      <div
        v-for="(locale, index) in data"
        :key="index"
        :slot="'td-' + index + '-edit'">
        <span
        @click="openupdateNotification(locale)">
          <rp-sprite class="create-icon" name="create"/>
        </span>
      </div>
      <div
        v-for="(notification, index) in data"
        :key="index"
        :slot="'td-' + index + '-remove'">
        <span
          @click="removeNotification(notification)">
          <rp-sprite class="create-icon delete" name="delete"/>
        </span>
      </div>
    </rp-table>

    <rp-overlay :active="isCreateFormOpen">
      <rp-editor
        @close="closeAddNotification"
        :isCreateForm="true"
        />
    </rp-overlay>

    <rp-overlay :active="isUpdateFormOpen">
      <rp-editor
        @close="closeupdateNotification"
        :isCreateForm="false"
        v-model="updateNotification"/>
    </rp-overlay>

  </div>
</template>

<script>
import page from '@/mixins/page'
import {mapGetters} from 'vuex'

import Overlay from 'raypro_ui/src/components/ui/Overlay'
import Breadcrumbs from '@/components/Breadcrumbs'
import Button from 'raypro_ui/src/components/ui/inputs/Button'
import Table from 'raypro_ui/src/components/ui/Table'
import Sprite from 'raypro_ui/src/components/ui/Sprite'
import LanguageForm from 'raypro_ui/src/components/ui/forms/Language'
import TextEditor from 'raypro_ui/src/components/SystemNotificationEditor'

import {getAdminSystemNotifications, removeSystemNotification} from 'raypro_ui/src/api/system_notifications'

export default {
  components: {
    'rp-button': Button,
    'rp-table': Table,
    'rp-editor': TextEditor,
    'rp-overlay': Overlay,
    'rp-sprite': Sprite,
    'rp-language-form': LanguageForm,
    Breadcrumbs
  },

  mixins: [page],

  computed: {
    ...mapGetters([
      'authUser'
    ])
  },

  data() {
    return {
      title: 'Manage Notification',
      breadcrumbs: [
        {label: 'Manage Notifications'}
      ],
      isCreateFormOpen: false,
      isUpdateFormOpen: false,
      updateNotification: {},
      data: {},
      tableState: 0,
      months: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
    }
  },

  methods: {
    openAddLanguage() {
      this.isCreateFormOpen = true
    },

    closeAddNotification(shouldRefreshTable) {
      this.isCreateFormOpen = false
      if(shouldRefreshTable) { this.tableState++ }
    },

    openupdateNotification(notification) {
      this.updateNotification = notification
      this.isUpdateFormOpen = true
    },

    removeNotification(notification) {
      removeSystemNotification(notification).then(() => {
        this.tableState++
      })
    },

    closeupdateNotification(shouldRefreshTable) {
      this.isUpdateFormOpen = false
      if(shouldRefreshTable) { this.tableState++ }
    },

    getNotifications() {
      return getAdminSystemNotifications().then((res) => {
        const mapped = res.data.map((row) => {
          const updateDate = new Date(row.updated_at)
          const createDate = new Date(row.inserted_at)

          return {
            id: row.id,
            content: row.content,
            contentDisplay: row.content.replace(/<[^>]+>/g, ' '),
            updated: `${updateDate.getDate()} ${this.months[updateDate.getMonth()].toUpperCase()} ${updateDate.getFullYear()}`,
            created: `${createDate.getDate()} ${this.months[createDate.getMonth()].toUpperCase()} ${createDate.getFullYear()}`
          }
        })

        this.data = mapped

        return {data: mapped}
      })
    }

  }
}
</script>

<style lang="sass" scoped>
  @import 'raypro_ui/src/styles/main.sass'
  @import '../../../stylesheets/helpers/mixins'

  .breadcrumbs

    .right-items
      flex-basis: auto

      button
        margin-left: auto
        margin-right: 0
</style>



// WEBPACK FOOTER //
// src/components/pages/Settings/ManageNotifications.vue